import { QuoteType } from './quoteType.js';

export const quoteTypes = Object.freeze({
  auto: Object.freeze(new QuoteType('AUTO', 'Auto')),
  home: Object.freeze(new QuoteType('HOME', 'Home')),
  renter: Object.freeze(new QuoteType('RENTER', 'Renter')),
  medsupp: Object.freeze(new QuoteType('MEDSUPP', 'Medsupp')),
  health: Object.freeze(new QuoteType('HEALTH', 'Health')),
  life: Object.freeze(new QuoteType('LIFE', 'Life')),
});
